import { render, staticRenderFns } from "./addAdudition.vue?vue&type=template&id=99d325fe&scoped=true"
import script from "./addAdudition.vue?vue&type=script&lang=js"
export * from "./addAdudition.vue?vue&type=script&lang=js"
import style0 from "./addAdudition.vue?vue&type=style&index=0&id=99d325fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d325fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99d325fe')) {
      api.createRecord('99d325fe', component.options)
    } else {
      api.reload('99d325fe', component.options)
    }
    module.hot.accept("./addAdudition.vue?vue&type=template&id=99d325fe&scoped=true", function () {
      api.rerender('99d325fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frontbusiness/auditionManage/addAdudition.vue"
export default component.exports